export const AUTHENTICATION_SET_DATA = 'AUTHENTICATION_SET_DATA'
